/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Recherche globale de l\'espace pro (barre du header)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GlobalSearchRecentActivityDto
 */
export interface GlobalSearchRecentActivityDto {
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    type: string;
    /**
     * risqueAssureId -> navigation vers le dossier
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    statusLabel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    branchCode?: string | null;
    /**
     * Dossiers EMPRUNTEUR uniquement (cf. GlobalSearchItemDto.borrowerProjectId)
     * @type {string}
     * @memberof GlobalSearchRecentActivityDto
     */
    borrowerProjectId?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GlobalSearchRecentActivityDto
     */
    date?: Date | null;
}

/**
 * Check if a given object implements the GlobalSearchRecentActivityDto interface.
 */
export function instanceOfGlobalSearchRecentActivityDto(value: object): value is GlobalSearchRecentActivityDto {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function GlobalSearchRecentActivityDtoFromJSON(json: any): GlobalSearchRecentActivityDto {
    return GlobalSearchRecentActivityDtoFromJSONTyped(json, false);
}

export function GlobalSearchRecentActivityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchRecentActivityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'id': json['id'],
        'title': json['title'],
        'statusLabel': json['statusLabel'] == null ? undefined : json['statusLabel'],
        'branchCode': json['branchCode'] == null ? undefined : json['branchCode'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
    };
}

export function GlobalSearchRecentActivityDtoToJSON(json: any): GlobalSearchRecentActivityDto {
    return GlobalSearchRecentActivityDtoToJSONTyped(json, false);
}

export function GlobalSearchRecentActivityDtoToJSONTyped(value?: GlobalSearchRecentActivityDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'id': value['id'],
        'title': value['title'],
        'statusLabel': value['statusLabel'],
        'branchCode': value['branchCode'],
        'borrowerProjectId': value['borrowerProjectId'],
        'date': value['date'] == null ? undefined : ((value['date'] as any).toISOString()),
    };
}

